import httpClient from './httpClient';

const extractFromFile = async (file, mode = 'sales_order') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('mode', mode);

  const response = await httpClient.post('/api/sales/import/extract', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

const getPreview = async (extractedData) => {
  const response = await httpClient.post('/api/sales/import/preview', extractedData);
  return response.data;
};

const importSalesOrder = async (orderData) => {
  const response = await httpClient.post('/api/sales/import', orderData);
  return response.data;
};

const importQuotation = async (quotationData) => {
  const response = await httpClient.post('/api/sales/import/quotation', quotationData);
  return response.data;
};

const getImportHistory = async (page = 1, limit = 20) => {
  const response = await httpClient.get('/api/sales/import/history', {
    params: { page, limit }
  });
  return response.data;
};

const salesImportService = {
  extractFromFile,
  getPreview,
  importSalesOrder,
  importQuotation,
  getImportHistory
};

export default salesImportService;
